/* ============================================================
   AIDEN — comportamiento de la capa de diseño
   Lo que el CSS solo no puede hacer:
   1. animar la altura de los acordeones (<details> no interpola),
   2. escalonar las líneas del contenido del acordeón,
   3. la entrada de la página,
   4. cerrar el carrito desde el botón flotante,
   5. el aviso de "agregado al carrito" (la referencia avisa, no abre el cajón),
   6. cerrar el buscador al hacer clic afuera o con Escape.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DUR = 300; // debe coincidir con --a-dur-acc en aiden.css

  /* ---------- 1 y 2. Acordeones ---------- */

  // El contenido viene de un rich text del editor. Para escalonarlo hay que
  // partirlo en líneas: cada nodo de texto suelto pasa a ser un <span class="line">.
  function marcarLineas(contenido) {
    if (contenido.dataset.aidenLineas === 'ok') return;
    contenido.dataset.aidenLineas = 'ok';
    var parrafos = contenido.querySelectorAll('p, li');
    if (!parrafos.length) return;
    parrafos.forEach(function (p) {
      if (p.querySelector('.line')) return;
      var nodos = Array.prototype.slice.call(p.childNodes);
      nodos.forEach(function (n) {
        if (n.nodeType !== 3 || !n.textContent.trim()) return;
        var span = document.createElement('span');
        span.className = 'line';
        span.textContent = n.textContent;
        p.replaceChild(span, n);
      });
    });
  }

  function abrir(det, contenido) {
    det.open = true;
    marcarLineas(contenido);
    if (reduce.matches) {
      contenido.style.height = 'auto';
      return;
    }
    contenido.style.height = '0px';
    contenido.style.paddingTop = '0px';
    contenido.style.paddingBottom = '0px';
    // reflow para que el navegador registre el punto de partida
    void contenido.offsetHeight;
    contenido.style.height = contenido.scrollHeight + 'px';
    contenido.style.paddingTop = '';
    contenido.style.paddingBottom = '';
    window.setTimeout(function () {
      if (det.open) contenido.style.height = 'auto';
    }, DUR);
  }

  function cerrar(det, contenido) {
    if (reduce.matches) {
      det.open = false;
      contenido.style.height = '';
      return;
    }
    contenido.style.height = contenido.scrollHeight + 'px';
    void contenido.offsetHeight;
    contenido.style.height = '0px';
    contenido.style.paddingTop = '0px';
    contenido.style.paddingBottom = '0px';
    window.setTimeout(function () {
      det.open = false;
      contenido.style.height = '';
      contenido.style.paddingTop = '';
      contenido.style.paddingBottom = '';
    }, DUR);
  }

  function prepararAcordeon(det) {
    if (det.dataset.aidenAcc === 'ok') return;
    var sum = det.querySelector('summary');
    var contenido = det.querySelector('.accordion__content');
    if (!sum || !contenido) return;
    det.dataset.aidenAcc = 'ok';

    if (!det.open) {
      contenido.style.height = '0px';
      contenido.style.paddingTop = '0px';
      contenido.style.paddingBottom = '0px';
    } else {
      marcarLineas(contenido);
    }

    sum.addEventListener('click', function (e) {
      e.preventDefault();
      sum.setAttribute('aria-expanded', det.open ? 'false' : 'true');
      if (det.open) cerrar(det, contenido);
      else abrir(det, contenido);
    });
  }

  function prepararAcordeones(raiz) {
    (raiz || document).querySelectorAll('.product__accordion details').forEach(prepararAcordeon);
  }

  /* ---------- 3. Entrada de la página ---------- */
  function entrada() {
    var main = document.getElementById('MainContent');
    if (!main || !main.classList.contains('fade-in-section')) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        main.classList.add('visible');
      });
    });
  }

  /* ---------- 4. Cierre del carrito ---------- */
  function prepararCarrito() {
    var drawer = document.querySelector('cart-drawer');
    var btn = document.querySelector('.button-close-drawer');
    if (!drawer || !btn || btn.dataset.aidenCart === 'ok') return;
    btn.dataset.aidenCart = 'ok';
    btn.addEventListener('click', function () {
      if (typeof drawer.close === 'function') drawer.close();
      else drawer.classList.remove('active');
    });

    // Tocar fuera del panel lo cierra. No alcanza con el overlay de Dawn: en
    // escritorio el cajón deja pasar los clics a la página (pointer-events:
    // none) y en iOS un div sin cursor no dispara click. Se escucha el
    // pointerdown en captura y se frena el click que le sigue, para que el
    // toque que cierra no abra además el producto que había debajo.
    var frenarClick = false;
    document.addEventListener('pointerdown', function (e) {
      if (!drawer.classList.contains('active')) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.drawer__inner, .button-close-drawer, #cart-icon-bubble, .aiden-aviso, #PBarNextFrame')) return;
      frenarClick = true;
      // si el toque era un arrastre y no llega ningún click, no comerse el próximo
      setTimeout(function () { frenarClick = false; }, 700);
      if (typeof drawer.close === 'function') drawer.close();
      else drawer.classList.remove('active');
    }, true);
    document.addEventListener('click', function (e) {
      if (!frenarClick) return;
      frenarClick = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  /* ---------- 5. Aviso de agregado al carrito ---------- */
  var avisoTimer = null;

  function textoAviso() {
    var el = document.querySelector('[data-aiden-texto-agregado]');
    return el ? el.getAttribute('data-aiden-texto-agregado') : 'Agregado al carrito';
  }

  function mostrarAviso() {
    var aviso = document.querySelector('.aiden-aviso');
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'aiden-aviso';
      aviso.setAttribute('role', 'status');
      aviso.setAttribute('aria-live', 'polite');
      aviso.innerHTML =
        '<span class="aiden-aviso__punto" aria-hidden="true"></span>' +
        '<span class="aiden-aviso__texto"></span>';
      // Botón, no <a href="#">: abre el cajón, no navega a ningún lado.
      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'aiden-aviso__link';
      var metaVer = document.querySelector('[data-aiden-ver-carrito]');
      link.textContent = (metaVer && metaVer.dataset.aidenVerCarrito) || 'Ver carrito';
      link.addEventListener('click', function () {
        ocultarAviso();
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') d.open();
      });
      aviso.appendChild(link);
      document.body.appendChild(aviso);
    }
    aviso.querySelector('.aiden-aviso__texto').textContent = textoAviso();
    aviso.classList.remove('saliendo');
    // reiniciar la animación si el aviso ya estaba puesto
    aviso.classList.remove('visible');
    void aviso.offsetWidth;
    aviso.classList.add('visible');
    window.clearTimeout(avisoTimer);
    avisoTimer = window.setTimeout(ocultarAviso, 2600);
  }

  function ocultarAviso() {
    var aviso = document.querySelector('.aiden-aviso');
    if (!aviso || !aviso.classList.contains('visible')) return;
    aviso.classList.add('saliendo');
    window.setTimeout(function () {
      aviso.classList.remove('visible', 'saliendo');
    }, 350);
  }

  /* ---------- 6. Buscador ---------- */
  function prepararBuscador() {
    // header-search.liquid se renderiza DOS veces: una en el header y otra
    // dentro del menu de celular. Con querySelector solo se preparaba la
    // primera del DOM (la del menu, invisible en escritorio), asi que la
    // pastilla del header se quedaba sin nada: por eso el foco no caia en el
    // campo y hacia falta un segundo clic.
    [].forEach.call(document.querySelectorAll('.header__search details'), prepararUnBuscador);
  }

  function prepararUnBuscador(caja) {
    if (!caja || caja.dataset.aidenSearch === 'ok') return;
    caja.dataset.aidenSearch = 'ok';

    // Dentro del menu de celular la pastilla no se usa: el campo se ve
    // siempre. Pero el <details> seguia cerrado, y con un <details> cerrado
    // el navegador no deja tocar lo de adentro por mas que el CSS lo muestre.
    // Por eso el buscador del menu no respondia.
    vigilarSugerencias(caja);
    prepararComodin(caja);
    comodinEnSugerencias();

    if (caja.closest('.menu-drawer')) {
      var lim = caja.querySelector('.reset__button');
      var pan = caja.querySelector('[data-predictive-search]');
      var inp = caja.querySelector('.header__search-input');
      if (lim && pan) lim.addEventListener('click', function () {
        pan.innerHTML = ''; if (inp) { inp.value = ''; inp.focus(); }
      });
      // Los resultados se mezclaban con "All" / "Archive 01". Mientras hay
      // algo escrito, la navegacion se esconde; al borrar, vuelve.
      var nav = caja.closest('.menu-drawer').querySelector('.menu-drawer__navigation');
      function alternar() {
        var escribiendo = !!(inp && inp.value.trim());
        if (nav) nav.style.display = escribiendo ? 'none' : '';
      }
      if (inp && pan) inp.addEventListener('input', function () {
        if (!inp.value.trim()) pan.innerHTML = '';
        alternar();
      });
      if (lim) lim.addEventListener('click', function () { window.setTimeout(alternar, 0); });
      caja.open = true;
      // Si algo lo cierra (por ejemplo al limpiar el campo con la X), el
      // <details> queda cerrado y no se puede volver a tocar nada de
      // adentro. Se vuelve a abrir solo.
      caja.addEventListener('toggle', function () {
        if (!caja.open) caja.open = true;
      });
      return;
    }
    var sum = caja.querySelector('summary');
    var input = caja.querySelector('.header__search-input');

    caja.addEventListener('toggle', function () {
      if (sum) sum.setAttribute('aria-expanded', caja.open ? 'true' : 'false');
    });

    // El <details> abria bien al primer clic, pero el navegador le daba el
    // foco al <summary> despues de todo (incluso despues de dos
    // requestAnimationFrame), asi que el cursor nunca caia en el campo y
    // habia que hacer un segundo clic para poder escribir. Se toma el
    // control: se cancela el comportamiento propio del <summary>, se abre a
    // mano y se enfoca el campo. Enter y barra sobre el summary tambien
    // disparan 'click', asi que el teclado sigue andando igual.
    // Al limpiar con la X quedaban los productos de la busqueda anterior
    // colgados en el panel.
    var limpiar = caja.querySelector('.reset__button');
    var panel = caja.querySelector('[data-predictive-search]');
    if (limpiar && panel) {
      limpiar.addEventListener('click', function () {
        panel.innerHTML = '';
        if (input) { input.value = ''; input.focus(); }
      });
    }
    if (input && panel) {
      input.addEventListener('input', function () {
        if (!input.value.trim()) panel.innerHTML = '';
      });
    }

    if (sum) {
      // El navegador le da el foco al <summary> en mousedown, antes del
      // click: por eso cancelar el click no alcanzaba y el cursor nunca
      // caia en el campo. Se cancela el mousedown, que es lo que enfoca.
      // El teclado no dispara mousedown, asi que Enter y barra siguen
      // funcionando y el foco por teclado se conserva.
      sum.addEventListener('mousedown', function (e) { e.preventDefault(); });
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        caja.open = !caja.open;
        // Cada vez que se abre, el campo arranca limpio: antes quedaba lo
        // que se habia escrito la vez anterior.
        if (caja.open && input) {
          input.value = '';
          var pan2 = caja.querySelector('[data-predictive-search]');
          if (pan2) pan2.innerHTML = '';
        }
        if (caja.open && input) {
          // Cancelar el mousedown no alcanzo: el navegador igual deja el
          // foco en el <summary>. Se lo saca a mano y recien ahi se enfoca
          // el campo, en el proximo turno del event loop.
          // Hay handlers del propio Dawn que corren despues y devuelven el
          // foco al <summary>. En vez de pelear en el mismo tick, se
          // reintenta unas cuantas veces durante los primeros 250ms hasta
          // que el campo se queda con el foco.
          var intentos = 0;
          (function insistir() {
            if (sum.blur) sum.blur();
            input.focus({ preventScroll: true });
            // La pastilla se ensancha con una transicion de 300ms; hasta
            // que no termina, el campo puede no aceptar el foco. Se insiste
            // durante medio segundo.
            if (document.activeElement !== input && intentos++ < 25) {
              window.setTimeout(insistir, 20);
            }
          })();
        } else if (sum.focus) sum.focus();
      });
    }
    document.addEventListener('click', function (e) {
      if (caja.open && !caja.contains(e.target)) caja.open = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && caja.open) {
        caja.open = false;
        if (sum) sum.focus();
      }
    });
  }


  /* ---------- 7. Filtros en castellano ----------
     Las etiquetas las genera Search & Discovery y viven en la tienda, no en
     el tema, así que no se pueden traducir desde el archivo de idioma. */
  var FILTROS = {
    'Availability': 'Disponibilidad', 'Price': 'Precio', 'Color': 'Color',
    'Size': 'Talle', 'Brand': 'Marca', 'Product type': 'Tipo de producto',
    'In stock': 'Con stock', 'Out of stock': 'Sin stock',
    'From': 'Desde', 'To': 'Hasta', 'Reset': 'Limpiar', 'Apply': 'Aplicar',
    'Filter': 'Filtrar', 'Filter:': 'Filtrar:'
  };
  function traducirFiltros(raiz) {
    var sel = '.facets__summary span, .facets__label, .facets__heading,' +
      ' .mobile-facets__summary span, .facet-checkbox span, .field__label,' +
      ' .facets__reset, .facets__button, .mobile-facets__label';
    (raiz || document).querySelectorAll(sel).forEach(function (el) {
      if (el.children.length) return;
      var t = el.textContent.trim();
      if (FILTROS[t]) el.textContent = el.textContent.replace(t, FILTROS[t]);
    });
  }

  /* ---------- 8. Rayitas de la galería en celular ----------
     Una por foto, la actual en negro. En escritorio ese trabajo lo hace la
     tira de miniaturas, así que sólo se dibujan abajo de 750px. */
  function prepararRayitas() {
    if (window.innerWidth > 749) return;
    var galeria = document.querySelector('.product__media-wrapper media-gallery, .product__media-wrapper');
    if (!galeria || galeria.querySelector('.aiden-rayitas')) return;
    var fotos = galeria.querySelectorAll('.product__media-item, .product__media-list li');
    if (fotos.length < 2) return;

    var barra = document.createElement('div');
    barra.className = 'aiden-rayitas';
    barra.style.display = 'flex';
    fotos.forEach(function () { barra.appendChild(document.createElement('span')); });
    var lista = galeria.querySelector('.product__media-list') || galeria;
    lista.insertAdjacentElement('afterend', barra);

    var marcas = barra.querySelectorAll('span');
    marcas[0].classList.add('activa');
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = [].indexOf.call(fotos, e.target);
          marcas.forEach(function (m, j) { m.classList.toggle('activa', j === i); });
        });
      }, { threshold: 0.6, root: lista.scrollWidth > lista.clientWidth ? lista : null });
      fotos.forEach(function (f) { obs.observe(f); });
    }
  }

  /* ---------- 8b. Miniaturas de la ficha (escritorio) ----------
     La galeria esta apilada, no es un slider: al tocar una miniatura Dawn
     marcaba el recuadro pero no movia la pagina, y al scrollear el recuadro
     se quedaba en la primera. Se atan las dos cosas por el data-media-id. */
  function sincronizarMiniaturas() {
    if (window.innerWidth <= 749) return;
    var galeria = document.querySelector('.product__media-wrapper');
    if (!galeria || galeria.dataset.aidenMinis === 'ok') return;
    var minis = [].slice.call(galeria.querySelectorAll('.thumbnail-list__item'));
    var fotos = [].slice.call(galeria.querySelectorAll('.product__media-item'));
    if (minis.length < 2 || !fotos.length) return;
    galeria.dataset.aidenMinis = 'ok';

    function fotoDe(mini) {
      var id = mini.getAttribute('data-target');
      if (!id) return null;
      for (var i = 0; i < fotos.length; i++) {
        if (fotos[i].getAttribute('data-media-id') === id) return fotos[i];
      }
      return null;
    }
    function marcar(foto) {
      minis.forEach(function (m) {
        var activa = fotoDe(m) === foto;
        var btn = m.querySelector('[aria-current], button, .thumbnail') || m;
        if (activa) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
        m.classList.toggle('aiden-mini-activa', activa);
      });
    }

    // Tocar la miniatura lleva a la foto.
    minis.forEach(function (m) {
      m.addEventListener('click', function () {
        var f = fotoDe(m);
        if (!f) return;
        var y = f.getBoundingClientRect().top + window.scrollY;
        var header = document.querySelector('.header');
        var alto = header ? header.getBoundingClientRect().height : 0;
        window.scrollTo({ top: Math.max(0, y - alto - 12), behavior: 'smooth' });
      });
    });

    // Scrollear mueve el recuadro a la foto que se esta viendo.
    if ('IntersectionObserver' in window) {
      var visibles = [];
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          var i = visibles.indexOf(e.target);
          if (e.isIntersecting && i === -1) visibles.push(e.target);
          if (!e.isIntersecting && i !== -1) visibles.splice(i, 1);
        });
        if (!visibles.length) return;
        // la que este mas arriba de las visibles manda
        var arriba = visibles.slice().sort(function (a, b) {
          return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
        })[0];
        marcar(arriba);
      }, { threshold: 0.35 });
      fotos.forEach(function (f) { obs.observe(f); });
    }
  }

  /* ---------- 8c. Cerrar el menu de celular ----------
     El cajon se abre con un <details> y no traia forma de cerrarlo. */
  function cerrarMenu() {
    var caja = document.querySelector('#Details-menu-drawer-container');
    if (!caja || caja.dataset.aidenCerrar === 'ok') return;
    caja.dataset.aidenCerrar = 'ok';
    // Dawn bloquea el scroll del body mientras el cajon esta abierto y lo
    // suelta con su propio boton. Al cerrar con el nuestro, ese bloqueo
    // quedaba puesto y la pagina no se movia mas.
    function soltarScroll() {
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    }
    // Al abrir el menu, el buscador arranca limpio. Va aca porque en
    // celular la pastilla no se usa y el handler del <summary> nunca corre.
    caja.addEventListener('toggle', function () {
      if (!caja.open) return;
      var inp = caja.querySelector('.header__search-input');
      var pan = caja.querySelector('[data-predictive-search]');
      if (inp) inp.value = '';
      if (pan) pan.innerHTML = '';
      var nav = caja.querySelector('.menu-drawer__navigation');
      if (nav) nav.style.display = '';
    });

    var btn = caja.querySelector('.menu-drawer__cerrar');
    if (btn) {
      btn.addEventListener('click', function () {
        caja.open = false;
        soltarScroll();
        var sum = caja.querySelector('summary');
        if (sum && sum.focus) sum.focus();
      });
    }
    caja.addEventListener('toggle', function () {
      if (!caja.open) soltarScroll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && caja.open) caja.open = false;
    });
  }

  /* ---------- 8d. Ordenar ----------
     La referencia no usa el <select> del sistema: usa una pastilla propia
     que abre una lista. Se arma encima del <select> de Dawn, que queda
     escondido pero sigue siendo el que manda: al elegir se le asigna el
     valor y se dispara 'change', asi que la navegacion la sigue haciendo
     Dawn y sin JS el <select> funciona igual. */
  var ORDENES = [
    ['created-descending', 'Nuevo'],
    ['price-ascending', 'Precio (menor a mayor)'],
    ['price-descending', 'Precio (mayor a menor)']
  ];

  function prepararOrden() {
    var sel = document.querySelector('select[name="sort_by"]');
    if (!sel) return;
    var caja = sel.closest('.facet-filters__field') || sel.parentElement;
    if (!caja || caja.querySelector('.aiden-orden')) return;

    // solo las opciones que existan de verdad en la tienda
    var valores = [].map.call(sel.options, function (o) { return o.value; });
    var opciones = ORDENES.filter(function (o) { return valores.indexOf(o[0]) !== -1; });
    if (!opciones.length) return;

    var actual = opciones.filter(function (o) { return o[0] === sel.value; })[0] || opciones[0];

    var cont = document.createElement('div');
    cont.className = 'aiden-orden';

    var limpiar = document.createElement('button');
    limpiar.type = 'button';
    limpiar.className = 'aiden-orden__limpiar';
    limpiar.setAttribute('aria-label', 'Quitar el orden');
    limpiar.innerHTML = '<svg viewBox="0 0 10 10" width="9" height="9" aria-hidden="true">'
      + '<path d="M1 1l8 8M9 1l-8 8" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';
    limpiar.addEventListener('click', function (e) {
      e.stopPropagation();
      var u = new URL(window.location.href);
      u.searchParams.delete('sort_by');
      u.searchParams.delete('page');
      window.location.assign(u.toString());
    });

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'aiden-orden__pastilla';
    boton.setAttribute('aria-haspopup', 'listbox');
    boton.setAttribute('aria-expanded', 'false');
    boton.textContent = actual === opciones[0] && sel.value !== actual[0] ? 'Orden' : actual[1];
    if (!sel.value) boton.textContent = 'Orden';

    var lista = document.createElement('div');
    lista.className = 'aiden-orden__lista';
    lista.setAttribute('role', 'listbox');

    opciones.forEach(function (o) {
      var it = document.createElement('button');
      it.type = 'button';
      it.className = 'aiden-orden__opcion';
      it.setAttribute('role', 'option');
      it.dataset.valor = o[0];
      it.textContent = o[1];
      if (o[0] === sel.value) {
        it.classList.add('elegida');
        it.setAttribute('aria-selected', 'true');
      }
      it.addEventListener('click', function () {
        sel.value = o[0];
        // El 'change' sobre el <select> no siempre lo levanta Dawn, y el
        // catalogo quedaba sin reordenar. Se navega a mano, que es lo que
        // termina haciendo el tema igual.
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        boton.textContent = o[1];
        cerrar();
        window.setTimeout(function () {
          var u = new URL(window.location.href);
          if (u.searchParams.get('sort_by') !== o[0]) {
            u.searchParams.set('sort_by', o[0]);
            u.searchParams.delete('page');
            window.location.assign(u.toString());
          }
        }, 350);
      });
      lista.appendChild(it);
    });

    function abrir() { cont.classList.add('abierta'); boton.setAttribute('aria-expanded', 'true'); }
    function cerrar() { cont.classList.remove('abierta'); boton.setAttribute('aria-expanded', 'false'); }

    boton.addEventListener('click', function (e) {
      e.stopPropagation();
      if (cont.classList.contains('abierta')) cerrar(); else abrir();
    });
    document.addEventListener('click', function (e) {
      if (!cont.contains(e.target)) cerrar();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cont.classList.contains('abierta')) { cerrar(); boton.focus(); }
    });

    cont.appendChild(boton);
    // la X sale solo cuando hay un orden elegido
    if (sel.value && opciones.some(function (o) { return o[0] === sel.value; })) {
      cont.classList.add('con-orden');
      cont.appendChild(limpiar);
    }
    cont.appendChild(lista);
    caja.appendChild(cont);
    caja.classList.add('aiden-orden-listo');

    // El <select> de Dawn dibuja su propia pastilla de vidrio, asi que se
    // veian DOS: la gris ancha de atras y la mia encima. Ocultarlo por CSS
    // dependia de donde cayera la clase; se hace directo sobre el elemento.
    var envoltorio = sel.closest('.select') || sel;
    envoltorio.style.position = 'absolute';
    envoltorio.style.width = '1px';
    envoltorio.style.height = '1px';
    envoltorio.style.overflow = 'hidden';
    envoltorio.style.clipPath = 'inset(50%)';
    envoltorio.style.pointerEvents = 'none';
    var etiqueta = caja.querySelector('.facet-filters__label, h2');
    if (etiqueta) etiqueta.style.display = 'none';
  }

  /* ---------- 8e. Sugerencias del buscador ----------
     Shopify devuelve mezclado: sugerencias de texto, colecciones, paginas y
     productos, ordenado por relevancia. Con "C" la Campera caia decima y
     quedaba fuera del corte. Se dejan SOLO productos, en orden alfabetico,
     las primeras 4, y si hay mas se agrega "Ver mas". */
  var MAX_SUGERENCIAS = 4;

  function ordenarSugerencias(panel, termino) {
    if (!panel) return;
    ocultarAsterisco(panel);
    var items = [].slice.call(panel.querySelectorAll('li'));
    var productos = items.filter(function (li) {
      return !!li.querySelector('a[href*="/products/"]');
    });
    if (!productos.length) {
      var term0 = (termino || '').trim();
      if (term0) sinResultados(panel, term0);
      return;
    }
    // Se reordena DENTRO de la lista donde ya viven los productos. Antes se
    // usaba la ultima <ul> del panel, que es la de paginas y esta oculta:
    // los productos se mudaban ahi y no se veia ninguno.
    var lista = productos[0].parentElement;
    if (!lista) return;

    // fuera todo lo que no sea un producto
    items.forEach(function (li) {
      if (productos.indexOf(li) === -1) li.style.display = 'none';
    });

    /* Shopify busca ademas por marca, etiquetas y descripcion, y encima se
       come los signos: "S+", "S{", "'" o "T'" devolvian prendas igual, y "a"
       las devolvia todas porque la marca es AIDEN. Lo que se espera de un
       buscador es lo contrario: si escribo T, aparece lo que empieza con T.
       Asi que se filtra contra el TITULO, tal cual se tecleo, sin quitarle
       nada: "T'" y "T*" no empiezan ninguna palabra y por eso no dan nada. */
    function empiezaPorElTermino(li, term) {
      if (!term) return true;
      var t = titulo(li).toLowerCase();
      if (t.indexOf(term) === 0) return true;
      var palabras = t.split(/[\s\-\u2013\u2014_/]+/);
      for (var i = 0; i < palabras.length; i++) {
        if (palabras[i] && palabras[i].indexOf(term) === 0) return true;
      }
      return false;
    }

    function sinResultados(panel, term) {
      // Se cuelga del panel y se busca en el panel. Antes se colgaba del
      // padre del contenedor -- fuera del panel -- asi que el querySelector
      // no lo encontraba y cada tecla apilaba otro mensaje.
      var previos = panel.querySelectorAll('.aiden-sin-resultados');
      for (var i = 1; i < previos.length; i++) previos[i].parentElement.removeChild(previos[i]);
      var m = previos[0];
      if (!m) {
        m = document.createElement('p');
        m.className = 'aiden-sin-resultados';
        panel.appendChild(m);
      }
      m.textContent = 'Sin resultados para \u201C' + term + '\u201D';
      m.style.display = '';
    }

    function titulo(li) {
      var t = li.querySelector('.predictive-search__item-heading, h3, .h5');
      return ((t ? t.textContent : li.textContent) || '').replace(/\s+/g, ' ').trim();
    }
    var termLimpio = (termino || '').trim().toLowerCase();

    // fuera lo que no coincide con el titulo
    var coinciden = [];
    productos.forEach(function (li) {
      if (empiezaPorElTermino(li, termLimpio)) coinciden.push(li);
      else li.style.setProperty('display', 'none', 'important');
    });
    var aviso = panel.querySelector('.aiden-sin-resultados');
    if (termLimpio && !coinciden.length) {
      if (lista) lista.style.setProperty('display', 'none', 'important');
      var verM = panel.querySelector('.aiden-ver-mas');
      if (verM) verM.style.display = 'none';
      sinResultados(panel, termino.trim());
      return;
    }
    if (aviso) aviso.style.display = 'none';
    if (lista) lista.style.removeProperty('display');
    productos = coinciden;
    function empiezaCon(li) {
      if (!termLimpio) return 1;
      return titulo(li).toLowerCase().indexOf(termLimpio) === 0 ? 0 : 1;
    }
    productos = productos
      .map(function (li, i) { return { li: li, i: i }; })
      .sort(function (a, b) {
        var d = empiezaCon(a.li) - empiezaCon(b.li);
        return d !== 0 ? d : a.i - b.i;   // empate: como los mando Shopify
      })
      .map(function (x) { return x.li; });
    productos.forEach(function (li) { lista.appendChild(li); });

    // Cuantas entran de verdad: se mide el hueco que queda en el panel
    // debajo del campo. Antes se cortaba siempre en 4 y en celular sobraba
    // como media pantalla de vidrio vacio.
    var tope = MAX_SUGERENCIAS;
    var cont = panel.closest('.menu-drawer');
    if (cont) {
      var alto = productos[0].getBoundingClientRect().height || 76;
      var rc = cont.getBoundingClientRect();
      var rp = panel.getBoundingClientRect();
      var hueco = rc.bottom - rp.top - 60;   // 60 = aire + "Ver mas"
      var entran = Math.floor(hueco / alto);
      if (entran > tope) tope = Math.min(entran, 8);
    }

    var sobran = productos.length - tope;
    productos.forEach(function (li, i) {
      // Hay reglas viejas con !important que cortaban por posicion; un
      // estilo en linea sin !important perdia contra ellas y en celular
      // quedaba una fila de menos.
      if (i < tope) li.style.setProperty('display', 'list-item', 'important');
      else li.style.setProperty('display', 'none', 'important');
    });

    var verMas = panel.querySelector('.aiden-ver-mas');
    if (sobran > 0) {
      if (!verMas) {
        verMas = document.createElement('a');
        verMas.className = 'aiden-ver-mas';
      }
      if (lista.parentElement) lista.parentElement.appendChild(verMas);
      // Antes era un enlace a la pagina de busqueda. Ahora despliega el
      // resto ahi mismo, que es lo que se espera de una lista de sugerencias.
      verMas.removeAttribute('href');
      verMas.setAttribute('role', 'button');
      verMas.setAttribute('tabindex', '0');
      verMas.textContent = 'Ver más (' + sobran + ')';
      verMas.style.display = '';
      verMas.onclick = function (e) {
        e.preventDefault();
        productos.forEach(function (li) {
          li.style.setProperty('display', 'list-item', 'important');
        });
        verMas.style.display = 'none';
      };
    } else if (verMas) {
      verMas.style.display = 'none';
    }
  }

  function vigilarSugerencias(caja) {
    var panel = caja.querySelector('[data-predictive-search]');
    var input = caja.querySelector('.header__search-input');
    if (!panel || panel.dataset.aidenOrden === 'ok') return;
    panel.dataset.aidenOrden = 'ok';
    var obs = new MutationObserver(function () {
      obs.disconnect();
      try { ordenarSugerencias(panel, input ? input.value : ''); }
      finally { obs.observe(panel, { childList: true, subtree: true }); }
    });
    obs.observe(panel, { childList: true, subtree: true });
  }

  /* ---------- 8f. Buscar por prefijo ----------
     La busqueda de Shopify es por palabra entera: "Ca" no encuentra
     "Campera", hace falta "Ca*". Se le agrega el comodin al enviar el
     formulario, sin tocar lo que el usuario ve escrito. */
  function prepararComodin(caja) {
    var form = caja.querySelector('form');
    var input = caja.querySelector('.header__search-input');
    if (!form || !input || form.dataset.aidenComodin === 'ok') return;
    form.dataset.aidenComodin = 'ok';
    form.addEventListener('submit', function () {
      var v = (input.value || '').trim();
      if (v && v.slice(-1) !== '*') input.value = v + '*';
      // se lo devuelve enseguida para que no quede el asterisco a la vista
      window.setTimeout(function () { input.value = v; }, 0);
    });
  }

  /* Las sugerencias las pide Dawn por su cuenta con fetch, asi que el
     comodin del formulario no las alcanzaba: escribiendo "Ca" la API
     devolvia cero y con "Ca*" devolvia la campera. Se intercepta ese
     pedido y se le agrega el asterisco al termino. */
  /* El comodin del formulario solo corre al enviarlo. Si se llega a la pagina
     de resultados por otro lado -- un enlace, el boton de atras, la direccion
     escrita a mano -- la busqueda va sin asterisco y no encuentra nada:
     "/search?q=J" devolvia 0 y "/search?q=J*" devolvia JT - 01. Aca se repite
     la busqueda una sola vez, y solo si de verdad no hubo resultados. */
  function comodinEnResultados() {
    if (location.pathname.indexOf('/search') === -1) return;
    var u;
    try { u = new URL(location.href); } catch (e) { return; }
    var q = (u.searchParams.get('q') || '').trim();
    if (!q || q.slice(-1) === '*') return;
    try { if (sessionStorage.getItem('aidenComodinHecho') === q) return; } catch (e) {}
    if (document.querySelector('.card-wrapper, .grid__item')) return;
    try { sessionStorage.setItem('aidenComodinHecho', q); } catch (e) {}
    u.searchParams.set('q', q + '*');
    location.replace(u.pathname + u.search + u.hash);
  }

  /* El panel viene armado por Shopify con el termino ya asteriscado, asi que
     el boton decia literalmente Buscar "J*". El asterisco es cosa nuestra, no
     algo que el visitante tenga que ver. */
  function ocultarAsterisco(raiz) {
    if (!raiz || !document.createTreeWalker) return;
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null);
    var comillas = /['"\u2018\u2019\u201C\u201D]/;
    var nodo;
    while ((nodo = w.nextNode())) {
      var t = nodo.nodeValue;
      if (!t || t.indexOf('*') === -1 || !comillas.test(t)) continue;
      var limpio = t.replace(/\*(?=\s*['"\u2018\u2019\u201C\u201D])/g, '');
      if (limpio !== t) nodo.nodeValue = limpio;
    }
  }

  function comodinEnSugerencias() {
    if (window.__aidenFetchComodin) return;
    window.__aidenFetchComodin = true;
    var original = window.fetch;
    window.fetch = function (recurso, opciones) {
      try {
        var url = typeof recurso === 'string' ? recurso : (recurso && recurso.url);
        if (url && url.indexOf('/search/suggest') !== -1) {
          var u = new URL(url, window.location.origin);
          var q = (u.searchParams.get('q') || '').trim();
          var cambio = false;
          if (q && q.slice(-1) !== '*') { u.searchParams.set('q', q + '*'); cambio = true; }
          // Dawn pide 4 y Shopify contesta por relevancia: buscando "c" venian
          // los productos de demo y la campera quedaba afuera. Se piden 10,
          // que es el maximo, y el orden lo arregla ordenarSugerencias().
          if (u.searchParams.get('resources[limit]') !== '10') {
            u.searchParams.set('resources[limit]', '10');
            u.searchParams.set('resources[limit_scope]', 'each');
            cambio = true;
          }
          if (cambio) {
            var nueva = u.pathname + u.search;
            if (typeof recurso === 'string') recurso = nueva;
            else recurso = new Request(nueva, recurso);
          }
        }
      } catch (e) { /* si algo falla, se deja el pedido tal cual */ }
      return original.apply(this, [recurso, opciones]);
    };
  }

  /* ---------- 9. Enlaces del carrito ---------- */
  function enlacesCarrito() {
    var panel = document.querySelector('.drawer__inner');
    if (!panel || panel.querySelector('.cart-drawer__links')) return;
    var meta = document.querySelector('[data-aiden-pedidos]');
    if (!meta) return;
    var caja = document.createElement('div');
    caja.className = 'cart-drawer__links';
    // Los atributos son data-aiden-*, así que en dataset se leen con ese prefijo.
    [['aidenPedidos', '/account'], ['aidenCuenta', '/account'], ['aidenIniciarSesion', '/account/login']]
      .forEach(function (par) {
        var a = document.createElement('a');
        a.href = par[1];
        a.textContent = meta.dataset[par[0]] || '';
        if (a.textContent) caja.appendChild(a);
      });
    // Van siempre, con o sin productos: antes se colgaban del bloque de
    // "carrito vacío", que desaparece en cuanto agregás algo.
    panel.appendChild(caja);
  }

  /* ---------- 10. Slider de columnas del catálogo ---------- */
  function sliderColumnas() {
    if (window.innerWidth < 990) return;
    var grilla = document.querySelector('#product-grid, .product-grid');
    if (!grilla || document.querySelector('.aiden-columnas')) return;

    // El numero de arranque sale del ajuste del tema (Dawn pone la clase
    // grid--N-col-desktop), no de un 4 fijo: antes cambiar las columnas en el
    // panel no hacia nada porque esto lo pisaba siempre.
    var clase = (grilla.className || '').match(/grid--(\d)-col-desktop/);
    var porDefecto = clase ? parseInt(clase[1], 10) : 4;
    // clave nueva: la vieja ya tenia un 4 guardado en los navegadores y el
    // ajuste del tema no se hubiera visto nunca.
    var guardado = parseInt(localStorage.getItem('aiden-columnas-v2') || porDefecto, 10);
    if (!(guardado >= 2 && guardado <= 6)) guardado = porDefecto;
    var caja = document.createElement('div');
    caja.className = 'aiden-columnas';
    caja.innerHTML = '<input type="range" min="2" max="6" step="1" aria-label="Columnas">' +
      '<span class="aiden-columnas__n"></span>';
    document.body.appendChild(caja);

    var rango = caja.querySelector('input');
    var num = caja.querySelector('.aiden-columnas__n');
    function aplicar(n) {
      grilla.style.setProperty('--aiden-cols', n);
      num.textContent = n;
      localStorage.setItem('aiden-columnas-v2', n);
    }
    rango.value = guardado;
    aplicar(guardado);
    rango.addEventListener('input', function () { aplicar(+rango.value); });
  }


  /* ---------- 11. Aviso de "hay más productos" en celular ----------
     La lista del carrito se recorta por alto; si hay artículos fuera de
     vista se avisa con una línea abajo. */
  function avisoMasProductos() {
    var lista = document.querySelector('.cart-drawer cart-drawer-items');
    if (!lista) return;
    var cont = lista.parentElement;
    var aviso = cont.querySelector('.aiden-mas');
    if (!aviso) {
      aviso = document.createElement('p');
      aviso.className = 'aiden-mas';
      cont.appendChild(aviso);
    }
    var filas = lista.querySelectorAll('.cart-item').length;
    var hayMas = lista.scrollHeight - lista.clientHeight > 8;
    if (hayMas && filas > 1) {
      // Escribir textContent reemplaza un nodo hijo, y eso es justo lo que
      // vigila el observador de más abajo: si se escribe siempre, se llama a
      // sí mismo sin parar. Sólo se toca cuando el texto de verdad cambió.
      var texto = filas + ' productos — deslizá para ver el resto';
      if (aviso.textContent !== texto) aviso.textContent = texto;
      aviso.classList.add('visible');
    } else {
      aviso.classList.remove('visible');
    }
    if (!lista.dataset.aidenScroll) {
      lista.dataset.aidenScroll = 'ok';
      lista.addEventListener('scroll', function () {
        if (lista.scrollTop + lista.clientHeight >= lista.scrollHeight - 8) {
          aviso.classList.remove('visible');
        }
      });
    }
  }


  /* ---------- El carrito no vuelve arriba al cambiar algo ----------
     Al sumar, restar o quitar, Dawn reemplaza la lista entera por la que le
     manda Shopify. El nodo nuevo nace con el scroll en cero, asi que la lista
     saltaba al principio (medido: de 748 a 0 en compu, de 279 a 0 en celu).
     Se anota la posicion antes del click y se repone mientras dura el
     refresco. Si la persona scrollea en el medio, se deja de reponer: manda
     ella. */
  function mantenerScrollDelCarrito() {
    if (window.__aidenScrollCarrito) return;
    window.__aidenScrollCarrito = true;
    var BOTONES = 'cart-drawer .quantity__button, cart-drawer button[name="plus"],' +
                  ' cart-drawer button[name="minus"], cart-drawer cart-remove-button a,' +
                  ' cart-drawer cart-remove-button button';
    var guardado = null, vence = 0, obs = null;

    function lista() { return document.querySelector('cart-drawer cart-drawer-items'); }

    function reponer() {
      if (guardado === null) return;
      var l = lista();
      if (!l) return;
      // Se escribe el valor pedido y listo: el navegador lo recorta solo si la
      // lista quedo mas corta. Recortarlo a mano fallaba porque en ese
      // instante el alto todavia es 0 y terminaba escribiendo 0.
      if (Math.abs(l.scrollTop - guardado) > 1) l.scrollTop = guardado;
    }

    function detener() {
      if (obs) { obs.disconnect(); obs = null; }
      guardado = null;
    }

    document.addEventListener('pointerdown', function (e) {
      var b = e.target && e.target.closest && e.target.closest(BOTONES);
      if (!b) return;
      var cajon = document.querySelector('cart-drawer');
      var l = lista();
      if (!cajon || !l || !l.scrollTop) return;   // ya estaba arriba: nada que hacer
      guardado = l.scrollTop;
      vence = Date.now() + 4000;
      if (obs) obs.disconnect();
      // Se repone DENTRO del observador, que corre apenas Dawn cambia el DOM y
      // antes de que el navegador dibuje. Con setTimeout llegaba tarde: la
      // lista se veia arriba de todo durante 17ms y volvia. Eso era el
      // parpadeo. Poner scrollTop no modifica el DOM, asi que no se
      // retroalimenta.
      obs = new MutationObserver(function () {
        if (Date.now() > vence) { detener(); return; }
        reponer();
      });
      obs.observe(cajon, { childList: true, subtree: true });
      // una pasada mas cuando el alto ya esta calculado, por si la lista
      // crecio despues del ultimo cambio del DOM
      requestAnimationFrame(function () { requestAnimationFrame(reponer); });
      setTimeout(function () { reponer(); detener(); }, 2000);
    }, true);

    // Si la persona scrollea despues del click, manda ella.
    ['wheel', 'touchmove'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (guardado === null) return;
        if (e.target && e.target.closest && e.target.closest('cart-drawer')) detener();
      }, { capture: true, passive: true });
    });
  }

  /* ---------- Los numeros del carrito cambian en el acto ----------
     Al sumar o restar, Dawn tarda ~1,1s en traer la lista nueva y recien ahi
     la reemplaza entera: durante ese segundo no cambia nada y despues cambia
     todo de golpe. Eso es el parpadeo. Aca se recalcula el precio en el
     momento, asi que cuando llega el reemplazo ya dice lo mismo y no se nota.
     Si el servidor dijera otra cosa, gana el servidor. */
  function leerDinero(txt) {
    if (!txt) return null;
    var m = txt.match(/[\d][\d.,\s ]*/);
    if (!m) return null;
    var crudo = m[0].trim();
    var i = txt.indexOf(crudo);
    var prefijo = txt.slice(0, i), sufijo = txt.slice(i + crudo.length);
    var corte = Math.max(crudo.lastIndexOf('.'), crudo.lastIndexOf(','));
    var decimal = '', miles = '', decimales = 0;
    if (corte > -1) {
      var cola = crudo.slice(corte + 1);
      if (/^\d{1,2}$/.test(cola)) {
        decimal = crudo[corte]; decimales = cola.length;
        miles = decimal === ',' ? '.' : ',';
      } else { miles = crudo[corte]; }
    }
    var num = crudo;
    if (miles) num = num.split(miles).join('');
    if (decimal) num = num.replace(decimal, '.');
    var valor = parseFloat(num);
    if (!isFinite(valor)) return null;
    return { valor: valor, prefijo: prefijo, sufijo: sufijo, miles: miles || '.', decimal: decimal, decimales: decimales };
  }
  function escribirDinero(valor, molde) {
    var fijo = valor.toFixed(molde.decimales), partes = fijo.split('.');
    var entera = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, molde.miles);
    return molde.prefijo + entera + (molde.decimales ? molde.decimal + partes[1] : '') + molde.sufijo;
  }
  function precioDeLinea(fila) {
    // Uno por uno y en este orden: querySelector con lista separada por comas
    // devuelve el primero en orden del DOCUMENTO, no de la lista, y agarraba
    // la celda entera llevandose puesto el <div class="price"> y el spinner.
    var cand = ['.cart-item__totals .price', '.cart-item__price-wrapper .price', '.price'];
    for (var i = 0; i < cand.length; i++) {
      var e = fila.querySelector(cand[i]);
      if (e && !e.children.length && /\d/.test(e.textContent)) return e;
    }
    return null;
  }
  function numerosAlInstante() {
    if (window.__aidenNumeros) return;
    window.__aidenNumeros = true;
    var BOTONES = 'cart-drawer .quantity__button, cart-drawer button[name="plus"], cart-drawer button[name="minus"]';
    var previa = null;

    // La cantidad se anota ANTES del click: para cuando llega el click, Dawn
    // ya subio el input, y calcular con ese valor daba precios equivocados
    // (de 1 a 2 mostraba $525.000 en vez de $700.000).
    document.addEventListener('pointerdown', function (e) {
      previa = null;
      var b = e.target && e.target.closest && e.target.closest(BOTONES);
      if (!b) return;
      var fila = b.closest('.cart-item');
      var inp = fila && fila.querySelector('.quantity__input');
      var n = inp ? parseInt(inp.value, 10) : NaN;
      if (isFinite(n)) previa = n;
    }, true);

    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest(BOTONES);
      if (!b) return;
      var anterior = previa; previa = null;
      if (!isFinite(anterior) || anterior === null) return;   // sin dato firme, no se toca nada
      var fila = b.closest('.cart-item');
      if (!fila) return;
      var suma = /plus/.test(b.getAttribute('name') || b.className) ? 1 : -1;
      var nueva = anterior + suma;
      if (nueva < 1) return;                    // en 0 la fila se va: lo maneja Dawn
      var elLinea = precioDeLinea(fila);
      var linea = elLinea && leerDinero(elLinea.textContent);
      if (!linea || !anterior) return;
      var unitario = linea.valor / anterior;
      elLinea.textContent = escribirDinero(unitario * nueva, linea);
      var elTotal = document.querySelector('cart-drawer .totals__total-value, .totals__total-value');
      var total = elTotal && leerDinero(elTotal.textContent);
      if (total) elTotal.textContent = escribirDinero(total.valor + unitario * suma, total);
    });
  }

  function iniciar() {
    comodinEnResultados();   // primero: puede recargar la pagina
    prepararAcordeones();
    prepararCarrito();
    prepararBuscador();
    traducirFiltros();
    prepararRayitas();
    sincronizarMiniaturas();
    cerrarMenu();
    prepararOrden();
    enlacesCarrito();
    sliderColumnas();
    avisoMasProductos();
    mantenerScrollDelCarrito();
    numerosAlInstante();
    entrada();
  }

  // cart-drawer.js dispara esto en vez de abrir el cajón al agregar.
  document.addEventListener('aiden:item-agregado', mostrarAviso);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  // El editor de temas y las variantes rehacen el HTML de la sección.
  document.addEventListener('shopify:section:load', function (e) {
    prepararAcordeones(e.target);
    prepararCarrito();
    prepararBuscador();
  });
  document.addEventListener('shopify:block:select', function (e) {
    prepararAcordeones(e.target.closest('section') || document);
  });
  // Al cambiar de variante Dawn reemplaza .product__info-container, y al
  // agregar algo rehace el interior del cajón del carrito. Hay que volver a
  // preparar esas partes.
  //
  // Antes esto miraba TODO el documento y el callback modificaba el DOM, así
  // que se disparaba a sí mismo. Con un solo producto en el carrito no se
  // notaba; con dos, avisoMasProductos() escribía el texto en cada vuelta y
  // el bucle no paraba nunca: la página se congelaba al agregar el segundo
  // talle. Ahora hay tres frenos.
  var OBSERVADO = 'cart-drawer, .product__info-wrapper, #ProductGridContainer, .collection';
  var obs = new MutationObserver(function (registros) {
    // Freno 1: sólo trabajar si la mutación tocó algo que nos importa.
    var relevante = registros.some(function (r) {
      var n = r.target;
      return n && n.closest && n.closest(OBSERVADO);
    });
    if (!relevante) return;

    // Freno 2: desconectar mientras el callback modifica el DOM. disconnect()
    // vacía la cola, así que lo que hagamos acá no vuelve a entrar.
    obs.disconnect();
    try {
      prepararAcordeones();
      traducirFiltros();
      enlacesCarrito();
      avisoMasProductos();
      sincronizarMiniaturas();
      cerrarMenu();
      prepararOrden();
    } finally {
      observar();
    }
  });

  // Freno 3: mirar sólo el carrito y la ficha, no el documento entero. Se
  // observa el <body> porque esos contenedores se reemplazan enteros y un
  // observador colgado de ellos se perdería; el filtro de arriba descarta
  // todo lo demás sin hacer trabajo.
  function observar() {
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
  }
  observar();
})();
